"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALENDAR_FOCUS = void 0;
var CALENDAR_FOCUS;
(function (CALENDAR_FOCUS) {
    CALENDAR_FOCUS["THIS_MONTH"] = "THIS_MONTH";
    CALENDAR_FOCUS["LAST_MONTH"] = "LAST_MONTH";
})(CALENDAR_FOCUS = exports.CALENDAR_FOCUS || (exports.CALENDAR_FOCUS = {}));
